module.exports = __webpack_public_path__ + "static/img/314_TO8_2310_og.a8c7679.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/314_TO8_2310_og.jpg
// module id = dO8R
// module chunks = 0